import { useState, useEffect } from 'react'
import api from '../../services/api'
import toast from 'react-hot-toast'

export default function Respuestas() {
  const [items, setItems] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [editando, setEditando] = useState(null)
  const [form, setForm] = useState({ comando: '', titulo: '', contenido: '' })

  const cargar = async () => { const { data } = await api.get('/respuestas/rapidas'); setItems(data) }
  useEffect(() => { cargar() }, [])

  const guardar = async (e) => {
    e.preventDefault()
    try {
      if (editando) await api.put(`/respuestas/rapidas/${editando.id}`, form)
      else await api.post('/respuestas/rapidas', form)
      toast.success('Guardado')
      setShowModal(false); setEditando(null); setForm({ comando: '', titulo: '', contenido: '' })
      cargar()
    } catch (e) { toast.error(e.response?.data?.error || 'Error') }
  }

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar?')) return
    await api.delete(`/respuestas/rapidas/${id}`); cargar()
  }

  const editar = (item) => { setEditando(item); setForm({ comando: item.comando, titulo: item.titulo, contenido: item.contenido }); setShowModal(true) }

  return (
    <div className="page">
      <div className="flex justify-between items-center" style={{ marginBottom: 18 }}>
        <div>
          <h1 className="text-2xl font-bold">⚡ Respuestas rápidas</h1>
          <p className="text-muted">Atajos con /comando para responder al instante</p>
        </div>
        <button className="btn btn-primary" onClick={() => { setEditando(null); setForm({ comando: '', titulo: '', contenido: '' }); setShowModal(true) }}>+ Nueva</button>
      </div>

      <div className="card" style={{ padding: 0 }}>
        <table className="table table-card">
          <thead><tr><th>Comando</th><th>Título</th><th>Contenido</th><th>Uso</th><th></th></tr></thead>
          <tbody>
            {items.map(item => (
              <tr key={item.id}>
                <td data-label="Comando"><code style={{ background: 'var(--bg)', padding: '2px 8px', borderRadius: 4 }}>{item.comando}</code></td>
                <td data-label="Título">{item.titulo}</td>
                <td data-label="Contenido"><div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 260 }}>{item.contenido}</div></td>
                <td data-label="Uso">{item.vecesUsada} veces</td>
                <td>
                  <button className="btn btn-sm btn-ghost" onClick={() => editar(item)}>✏️</button>
                  <button className="btn btn-sm btn-ghost" onClick={() => eliminar(item.id)}>🗑️</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {items.length === 0 && <div className="empty-state">Sin respuestas rápidas</div>}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <span className="modal-title">{editando ? 'Editar' : 'Nueva'} respuesta rápida</span>
              <button className="btn btn-ghost btn-icon" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <form onSubmit={guardar}>
              <div className="modal-body">
                <div className="form-group"><label className="form-label">Comando (con /)</label><input className="input" required value={form.comando} onChange={e => setForm({...form, comando: e.target.value})} placeholder="/saludo" /></div>
                <div className="form-group"><label className="form-label">Título</label><input className="input" required value={form.titulo} onChange={e => setForm({...form, titulo: e.target.value})} placeholder="Saludo inicial" /></div>
                <div className="form-group"><label className="form-label">Contenido</label><textarea className="textarea" rows={5} required value={form.contenido} onChange={e => setForm({...form, contenido: e.target.value})} /></div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn" onClick={() => setShowModal(false)}>Cancelar</button>
                <button className="btn btn-primary">Guardar</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
